import React from 'react';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';

const OverviewCard = ({ overview, onEdit, onDelete }) => {
    return (
        <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-200 border border-slate-100">
            {/* Overview Image */}
            <div className="relative aspect-video bg-gradient-to-br from-primary-100 to-primary-200">
                {overview.image_url ? (
                    <img
                        src={overview.image_url}
                        alt={overview.title}
                        className="w-full h-full object-cover"
                    />
                ) : (
                    <div className="absolute inset-0 flex items-center justify-center text-slate-400">
                        <span className="text-sm font-medium">No Image</span>
                    </div>
                )}

                {/* Loan Type Badge */}
                <div className="absolute top-3 right-3 bg-white rounded-lg px-3 py-1.5 shadow-lg">
                    <span className="text-xs font-bold text-primary-600 uppercase">
                        {overview.loan_type?.replace(/_/g, ' ') || 'Overview'}
                    </span>
                </div>

                {/* Active/Inactive Badge */}
                <div className="absolute top-3 left-3">
                    <span className={`px-3 py-1.5 rounded-lg text-xs font-semibold shadow-lg ${overview.is_active
                        ? 'bg-green-500 text-white'
                        : 'bg-slate-400 text-white'
                        }`}>
                        {overview.is_active ? 'Active' : 'Inactive'}
                    </span>
                </div>
            </div>

            {/* Content */}
            <div className="p-5">
                {/* Title */}
                <h3 className="text-lg font-bold text-slate-800 mb-2 line-clamp-1">
                    {overview.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-slate-500 mb-4 line-clamp-3">
                    {overview.description}
                </p>

                {/* Action Buttons */}
                <div className="flex gap-2 pt-4 border-t border-slate-100">
                    <button
                        onClick={() => onEdit(overview)}
                        className="flex-1 flex items-center justify-center gap-2 bg-blue-50 hover:bg-blue-100 text-blue-600 px-4 py-2.5 rounded-xl font-medium transition-all duration-200"
                    >
                        <PencilIcon className="h-4 w-4" />
                        Edit
                    </button>
                    <button
                        onClick={() => onDelete(overview.id)}
                        className="flex-1 flex items-center justify-center gap-2 bg-red-50 hover:bg-red-100 text-red-600 px-4 py-2.5 rounded-xl font-medium transition-all duration-200"
                    >
                        <TrashIcon className="h-4 w-4" />
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OverviewCard;
